module.exports = __webpack_public_path__ + "static/media/logo.07ad8fc0.svg";